enum TaxiCargoContractListingSortKey {
  BILLING_MODEL_ASC = "BILLING_MODEL_ASC",
  BILLING_MODEL_DESC = "BILLING_MODEL_DESC",
  CARGO_COMPANY_ASC = "CARGO_COMPANY_ASC",
  CARGO_COMPANY_DESC = "CARGO_COMPANY_DESC",
  DISTANCE_RATE_ASC = "DISTANCE_RATE_ASC",
  DISTANCE_RATE_DESC = "DISTANCE_RATE_DESC",
  DISCOUNT_PERCENT_LIMIT_ASC = "DISCOUNT_PERCENT_LIMIT_ASC",
  DISCOUNT_PERCENT_LIMIT_DESC = "DISCOUNT_PERCENT_LIMIT_DESC",
  FREE_STOPPING_PERIOD_ASC = "FREE_STOPPING_PERIOD_ASC",
  FREE_STOPPING_PERIOD_DESC = "FREE_STOPPING_PERIOD_DESC",
  STOPPING_RATE_ASC = "STOPPING_RATE_ASC",
  STOPPING_RATE_DESC = "STOPPING_RATE_DESC",
  PERIOD_OF_VALIDITY_FROM_ASC = "PERIOD_OF_VALIDITY_FROM_ASC",
  PERIOD_OF_VALIDITY_FROM_DESC = "PERIOD_OF_VALIDITY_FROM_DESC",
  PERIOD_OF_VALIDITY_TO_ASC = "PERIOD_OF_VALIDITY_TO_ASC",
  PERIOD_OF_VALIDITY_TO_DESC = "PERIOD_OF_VALIDITY_TO_DESC",
}

export default TaxiCargoContractListingSortKey;
